var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading.small",value:(_vm.loading),expression:"loading",modifiers:{"small":true}}],staticClass:"button-wrapper",style:(_vm.style),on:{"click":_vm.btnAction}},[_c('div',{attrs:{"data-voicetext":_vm.bText}},[_vm._v(_vm._s(_vm.bText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }